module.exports = __webpack_public_path__ + "img/selected-marker-grey.eadeaba3.svg";